module.exports = __webpack_public_path__ + "static/react-typescript-f721a6d6d3295e35504b85a320b1ea41.png";